import React from 'react';
import { Link } from 'gatsby';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import logo from '../../img/logo.svg';

const Header = ({ title, description }) => {
  return (
    <HeaderWrapper>
      <NavContainer>
        <Link to="/">
          <img src={logo} alt="FilmChain" className="filmchain-icon" />
        </Link>
      </NavContainer>
      <HeaderContent>
        <Title>{title}</Title>
        <Subtitle>{description}</Subtitle>
      </HeaderContent>
    </HeaderWrapper>
  );
};

Header.propTypes = {
  title: PropTypes.string.isRequired,
  description: PropTypes.string,
};

export default Header;

const HeaderWrapper = styled.div`
  background: radial-gradient(50% 50% at 50% 50%, rgba(17, 13, 17, 0) 0%, #110d11 100%),
    url('/img/help-hub-header.jpg') lightgray 50% / cover no-repeat;
  display: flex;
  height: 360px;
  padding: 40px 180px 0 180px;
  flex-direction: column;
  align-items: flex-start;
  gap: 64px;
  @media screen and (max-width: 768px) {
    padding: 40px 20px 0 20px;
    align-self: stretch;
    flex-shrink: 0;
  }
`;

const NavContainer = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
`;

const HeaderContent = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 8px;
  max-width: 666px;
  @media screen and (max-width: 768px) {
    align-self: stretch;
  }
`;

const Title = styled.h1`
  color: #fff;
  font-size: 54px;
  font-weight: 600;
  line-height: 64px;
  @media screen and (max-width: 768px) {
    font-size: 28px;
    line-height: 36px;
  }
`;

const Subtitle = styled.div`
  color: #fff;
  font-size: 16px;
  font-weight: 400;
  line-height: 24px;
`;
